// to check any error in API response
export default function isErrorExist(res) {
  return res.errors || res.batchActionErrors
}
